(ns minorodata.usage-account.api
  (:require
   [minorodata.components.warehouse-usage.shared :as shared]
   [mold-http.core :refer [reg-event-http]]))

(defn query-cost-request [_ [{:keys [from to generation]}]]
  {:http-xhrio
   {:id        :usage-account-query-cost
    :url       "/api/usage/series/query-cost"
    :cb-params generation
    :params    {:from from :to to}}})

(defn query-cost-callback [{:keys [db]} [error resp generation]]
  (if (not= generation (get-in db [:usage-account :generation]))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :query-cost-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :query-cost-status] :error)
         :dispatch-n [[:app.events/add-snack :error "Failed to load Credits Breakdown data"]
                      [:app.api/log :error "Failed to load query cost" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :query-cost] {:rows (:rows resp) :totals (:totals resp)})
                 (assoc-in [:usage-account :query-cost-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-query-cost
  query-cost-request
  query-cost-callback)


(defn previous-totals-request [_ [{:keys [from to generation]}]]
  {:http-xhrio
   {:id        :usage-account-previous-totals
    :url       "/api/usage/totals"
    :cb-params generation
    :params    (shared/previous-window {:from from :to to})}})

(defn previous-totals-callback [{:keys [db]} [error resp generation]]
  (if (not= generation (get-in db [:usage-account :generation]))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :previous-totals-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :previous-totals-status] :error)
         :dispatch-n [[:app.api/log :error "Failed to load previous period totals" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :previous-totals] (:totals resp))
                 (assoc-in [:usage-account :previous-totals-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-previous-totals
  previous-totals-request
  previous-totals-callback)


(defn warehouse-runtime-request [_ [{:keys [from to generation]}]]
  {:http-xhrio
   {:id        :usage-account-warehouse-runtime
    :url       "/api/usage/series/warehouse-runtime"
    :cb-params generation
    :params    {:from from :to to}}})

(defn warehouse-runtime-callback [{:keys [db]} [error resp generation]]
  (if (not= generation (get-in db [:usage-account :generation]))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :warehouse-runtime-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :warehouse-runtime-status] :error)
         :dispatch-n [[:app.events/add-snack :error "Failed to load Execution Time data"]
                      [:app.api/log :error "Failed to load warehouse runtime" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :warehouse-runtime] (:rows resp))
                 (assoc-in [:usage-account :warehouse-runtime-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-warehouse-runtime
  warehouse-runtime-request
  warehouse-runtime-callback)


(defn load-profile-request [_ [{:keys [from to generation]}]]
  {:http-xhrio
   {:id        :usage-account-load-profile
    :url       "/api/usage/load-profile"
    :cb-params generation
    :params    {:from from :to to}}})

(defn load-profile-callback [{:keys [db]} [error resp generation]]
  (if (not= generation (get-in db [:usage-account :generation]))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :heatmap-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :heatmap-status] :error)
         :dispatch-n [[:app.events/add-snack :error "Failed to load Warehouse usage data"]
                      [:app.api/log :error "Failed to load load profile" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :load-profile] (:rows resp))
                 (assoc-in [:usage-account :heatmap-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-load-profile
  load-profile-request
  load-profile-callback)


(defn filter-options-request [_ [{:keys [from to generation]}]]
  {:http-xhrio
   {:id        :usage-account-filter-options
    :url       "/api/usage/query-filter-options"
    :cb-params generation
    :params    {:from from :to to}}})

(defn filter-options-callback [{:keys [db]} [error resp generation]]
  (if (not= generation (get-in db [:usage-account :diagnosis-generation]))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :filter-options-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :filter-options-status] :error)
         :dispatch-n [[:app.api/log :error "Failed to load query filter options" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :filter-options] (:rows resp))
                 (assoc-in [:usage-account :filter-options-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-filter-options
  filter-options-request
  filter-options-callback)


(defn shape-summary-request [_ [{:keys [from to query-type warehouse user generation seq]}]]
  {:http-xhrio
   {:id        :usage-account-shape-summary
    :url       "/api/usage/query-shape-summary"
    :cb-params {:generation generation :seq seq}
    :params    (cond-> {:from from :to to}
                 (not-empty query-type) (assoc :query-type query-type)
                 (not-empty warehouse)  (assoc :warehouse warehouse)
                 (not-empty user)       (assoc :user user))}})

(defn shape-summary-callback [{:keys [db]} [error resp {:keys [generation seq]}]]
  (if (or (not= generation (get-in db [:usage-account :diagnosis-generation]))
          (not= seq (get-in db [:usage-account :shape-summary-seq])))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :shape-summary-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :shape-summary-status] :error)
         :dispatch-n [[:app.api/log :error "Failed to load query shape summary" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :shape-summary] (:summary resp))
                 (assoc-in [:usage-account :shape-summary-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-shape-summary
  shape-summary-request
  shape-summary-callback)


(defn shapes-request [_ [{:keys [from to query-type warehouse user limit generation seq]}]]
  {:http-xhrio
   {:id        :usage-account-shapes
    :url       "/api/usage/query-shapes"
    :cb-params {:generation generation :seq seq}
    :params    (cond-> {:from from :to to :limit limit}
                 (not-empty query-type) (assoc :query-type query-type)
                 (not-empty warehouse)  (assoc :warehouse warehouse)
                 (not-empty user)       (assoc :user user))}})

(defn shapes-callback [{:keys [db]} [error resp {:keys [generation seq]}]]
  (if (or (not= generation (get-in db [:usage-account :diagnosis-generation]))
          (not= seq (get-in db [:usage-account :shapes-seq])))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :shapes-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :shapes-status] :error)
         :dispatch-n [[:app.events/add-snack :error "Failed to load Higher Cost Queries data"]
                      [:app.api/log :error "Failed to load query shapes" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :shapes] (:rows resp))
                 (assoc-in [:usage-account :shapes-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-shapes
  shapes-request
  shapes-callback)


(defn query-type-series-request [_ [{:keys [from to warehouse user generation seq]}]]
  {:http-xhrio
   {:id        :usage-account-query-type-series
    :url       "/api/usage/series/query-type"
    :cb-params {:generation generation :seq seq}
    :params    (cond-> {:from from :to to}
                 (not-empty warehouse) (assoc :warehouse warehouse)
                 (not-empty user)      (assoc :user user))}})

(defn query-type-series-callback [{:keys [db]} [error resp {:keys [generation seq]}]]
  (if (or (not= generation (get-in db [:usage-account :diagnosis-generation]))
          (not= seq (get-in db [:usage-account :query-type-series-seq])))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:usage-account :query-type-series-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:usage-account :query-type-series-status] :error)
         :dispatch-n [[:app.api/log :error "Failed to load query type series" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:usage-account :query-type-series] (:rows resp))
                 (assoc-in [:usage-account :query-type-series-status] :loaded))}))))

(reg-event-http
  :usage-account.api/fetch-query-type-series
  query-type-series-request
  query-type-series-callback)
